import React from  "react";
import { Icon } from 'antd'

export const zoomAppKey = {
    id: "zoom-controls", 
    title : "Zoom", 
    showTitle : false,
    icon: <Icon type="search" />, 
    defaultY: 75, 
    defaultX: 80
}
export const previewControlsKey = {
    id: "preview-controls", 
    title : "Preview", 
    showTitle : true, 
    icon: <Icon type="pic-center" />, 
    defaultY: 5, 
    defaultX: 60
}
export const annotationsAppKey = {
    id: "annotations", 
    title : "Annotations", 
    showTitle : true, 
    icon: <Icon type="edit" />, 
    defaultY: 60, 
    defaultX: 30
}
export const gridOverlayAppKey = {
    id: "grid-overlay", 
    title : "Grid", 
    showTitle : true, 
    icon: <Icon type="number" />, 
    defaultY: 20, 
    defaultX: 30
}
export const settingsAppKey = {
    id: "settings", 
    title : "Settings", 
    showTitle : true, 
    icon: <Icon type="setting" />, 
    defaultY: 10, 
    defaultX: 60
}
export const slideInfoAppKey = {
    id: "slide_info", 
    title : "Slide Info", 
    showTitle : true, 
    icon: <Icon type="info" />, 
    defaultY: 2, 
    defaultX: 30
}
export const screenshotAppKey = {
    id: "screenshot", 
    title : "Screenshot", 
    showTitle : true, 
    icon: <Icon type="export" />, 
    defaultY: 20, 
    defaultX: 30
}
export const reportAppKey = {
    id: "cap_report",
    title: "Report", 
    showTitle: true, 
    icon: <Icon type="profile" />, 
    defaultY: 2, 
    defaultX: 30
}
export const capGuideAppKey = {
    id: "cap_guide",
    title: "CAP Guidelines", 
    showTitle: true, 
    icon: <Icon type="read" />, 
    defaultY: 2, 
    defaultX: 30
}
export const ihcAppKey = {
    id: "ihc_app", 
    title : "IHC", 
    showTitle : true, 
    icon: <Icon type="experiment" />, 
    defaultY: 2, 
    defaultX: 30
}
export const presentAppKey = {
    id: "present_app", 
    title: "Scan Share", 
    showTitle: true,
    icon: <Icon type="team" />,
    defaultY: 2, 
    defaultX: 30
}
// export const chatAppKey = {
//     id: "chat", 
//     title : "Chat", 
//     showTitle : true
// }